import { Download, Features, SectionWrapper} from './components'
import assets from './assets'
import styles from './styles/Global';

const App = () => {
  return (
    <>
      <SectionWrapper 
        title='You own store of Nifty NFTs. Start Selling & Growing.'
        discription="Buy, store, collect NFTs, exchange & earn crypto join 23+ million people using ProNef Marketplace"
        showBtn
        mockupImg={assets.homeHero}
        banner="banner"
      />
      <SectionWrapper 
        title='Smart User Interface Marketplace'
        discription="Experience a buttery UI of ProNef NFT Marketplace. Smooth constant colors of a fluent UI design."
        mockupImg={assets.homeCards}
        reverse
      />
      <Features />
      <SectionWrapper 
        title='Deployment'
        discription="ProNef is built using Expo which runs natively on all user's devices. You can easily get your app into people's hands"
        mockupImg={assets.feature}
        reverse
      />
       <SectionWrapper 
        title='Creative way to showcase the store'
        discription="The app contains two screens. the first screen lists all NFTs while the second one shows the details of a specific NFT."
        mockupImg={assets.mockup}
        banner="banner02"
      />
      <Download />
      <div className="px-4 py-2 justify-center items-center bg-primary flex-col text-center banner04">
        <p className={`${styles.pText} ${styles.whiteText}`}>Made with love by {" "}
        <span className="bold">Blair Chappell</span>
        </p>
      </div>
    </>
  );
}

export default App;
